import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './translations';

//CHECK NAVIGATOR
let lang = navigator.language || navigator.userLanguage;

lang = lang.toLowerCase();
lang = lang.split("-");
if (lang.length > 1 && ['us', 'br'].includes(lang[1])) {
    lang = lang[1];
} else {
    lang = lang[0];
}

//CHECK URL
let part = (location.pathname.split("/").length > 0) ? location.pathname.split("/")[1] : "";
if (part.length == 2) {
    lang = part;
}

//FORCED
if (lang == "pt") {
    lang = "br";
}
if (messages[lang] == null) {
    lang = 'en';
}

Vue.use(VueI18n);
export const i18n = new VueI18n({
    locale: lang,
    messages,
});

export function setI18nLanguage(locale) {
    i18n.locale = locale
}


// WEBPACK FOOTER //
// ./src/i18n.js